// extracted by mini-css-extract-plugin
module.exports = {"THEME_NAME":"\"fixtercore\"","icon":"Icon_icon__Ol_xn"};